import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div>© 2026 Bansal Motors | G.T. Madanpur Road, Karnal | Call: 98129 99358</div>
      
    </footer>
  );
}


export default Footer;
